import { createContext, Dispatch, PropsWithChildren, SetStateAction } from "react";
import { MfaOption } from "./common/hooks/useLoginApi";
import { SecurityCodeMethod } from "./mfa/hooks/useMfaApi";

export interface MfaLoginData {
    username: string
    password: string
    type?: SecurityCodeMethod
    value?: string
    id?: string
    options?: MfaOption[]
}

export const defaultMfaLoginData = (): MfaLoginData => ({
    username: '',
    password: '',
});

interface GlobalData {
    enableHeaderTimeout: boolean
    setEnableHeaderTimeout: Dispatch<SetStateAction<boolean>>;
    showNewAccountLoginAlert: boolean
    setShowNewAccountLoginAlert: (show: boolean) => void
    mfaLoginData: MfaLoginData,
    setMfaLoginData: (data: MfaLoginData) => void
}

export const globalData = createContext<GlobalData>({
    enableHeaderTimeout: false,
    setEnableHeaderTimeout: () => {},
    showNewAccountLoginAlert: false,
    setShowNewAccountLoginAlert: () => {},
    mfaLoginData: defaultMfaLoginData(),
    setMfaLoginData: () => {}
});

interface GlobalDataProviderProps {
    value: GlobalData
}

export const GlobalDataProvider = (props: PropsWithChildren<GlobalDataProviderProps>) => (
    <globalData.Provider value={props.value}>
        {props.children}
    </globalData.Provider>
);